import React from 'react';
import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetRecentFormGameViewModel} from "../../models/standings-widget.recent-form-game.view-model";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";
import {ACTION_TYPES, WINNER_STATUSES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import {StandingsWidgetController} from "../../standings-widget.controller";
import styles from "../../styles/standings-widget.module.scss";
import classNames from "classnames";
import {Tooltip} from "../../../../core/components/tooltip/tooltip";
import {TOOLTIP_PLACEMENT} from "../../../../core/components/tooltip/tooltip-consts";
import {Link} from "../../../../core/components/link/link";
import {GameBadgeTooltipContent} from "../../../../core/components/game-badge/game-badge-tooltip/game-badge.tooltip-content";
import {StandingWidgetCompetitorViewModel} from "../../models/standings-widget.competitor-view-model";

export class StandingsWidgetRecentFormBadgeProps extends BaseProps {
  controller: StandingsWidgetController;
  game: StandingsWidgetRecentFormGameViewModel;
  competitor: StandingWidgetCompetitorViewModel;
}

export const StandingsWidgetRecentFormBadge = observer(({
                                                          controller,
                                                          game,
                                                          competitor
                                                        }: StandingsWidgetRecentFormBadgeProps) => {
  const {terms, state} = controller;
  const {currentLinkModel, highlightedCompetitors} = state;

  const {
    id,
    sport,
    domainModel,
    competition,
    homeCompetitor,
    awayCompetitor,
    statusGroup,
    linkModel,
    winnerStatus,
  } = game;

  const {
    GAME_CENTER_H2H_WIN,
    GAME_CENTER_H2H_DRAW,
    GAME_CENTER_H2H_LOSE,
  } = terms;

  const statusTexts = {
    [WINNER_STATUSES.win]: GAME_CENTER_H2H_WIN,
    [WINNER_STATUSES.draw]: GAME_CENTER_H2H_DRAW,
    [WINNER_STATUSES.lose]: GAME_CENTER_H2H_LOSE
  }

  const colors = {
    [WINNER_STATUSES.win]: styles.table_row_badge_win,
    [WINNER_STATUSES.draw]: styles.table_row_badge_draw,
    [WINNER_STATUSES.lose]: styles.table_row_badge_lose
  }

  const text = statusTexts[winnerStatus];
  const colorClassName = colors[winnerStatus];
  const isHighlighted = highlightedCompetitors.includes(competitor.id)

  const onMouseEnter = () => controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeHighlightedRows, {hoveredCompetitorIds: [homeCompetitor.id, awayCompetitor.id]});
  const onMouseLeave = () => controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeHighlightedRows, {hoveredCompetitorIds: []});
  const onClick = () => controller.action(ACTION_TYPES.matchDetailsClick, {
    gameId: id,
    competitionId: competition.id,
    status: statusGroup,
    source: APP.ANALYTICS.SOURCES[currentLinkModel.name],
    placement: APP.GOOGLE_ANALYTICS.SOURCES[currentLinkModel.name],
    currentLinkModelName: currentLinkModel.name,
    screenId: currentLinkModel.params.id,
    sportTypeId: sport.id
  });

  const linkProps = {
    className: classNames(styles.table_row_badge, {[styles.table_highlighted_row_badge]: isHighlighted}),
    model: linkModel,
    routeProps: {dataSource: {game: domainModel}},
    onClick,
    onMouseEnter,
    onMouseLeave,
  }

  const tooltipProps = {
    className: classNames(styles.table_row_badge_tooltip, colorClassName),
    placement: TOOLTIP_PLACEMENT.bottom,
    content: <GameBadgeTooltipContent game={game} isEnded/>,
  }

  return (
    <Link {...linkProps}>
      <Tooltip {...tooltipProps}>
        {text}
      </Tooltip>
    </Link>
  )
});
